var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.537 12.9582L27.4642 1.66667H25.1118L16.492 11.4709L9.60731 1.66667H1.66669L12.0776 16.4924L1.66669 28.3333H4.01926L13.122 17.9797L20.3927 28.3333H28.3334L17.537 12.9582ZM14.3148 16.6231L13.26 15.1468L4.86693 3.39957H8.48035L15.2536 12.8799L16.3085 14.3562L25.1129 26.6792H21.4995L14.3148 16.6231Z",
    fill: "#232F3C",
    className: "social-icon"
  })));
};
export default SvgTwitter;